import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { Link } from 'ui/base/link';
import { Theme, useStyles } from 'ui/base/theme';
import { ActiveButton } from 'ui/public/button';
import { PartitionedPage } from 'ui/add_pangolin/partitioned_page/partitioned_page';

import { BasePath } from 'services/base/page_path';
import { useAccountsDomain } from 'services/accounts/accounts_domain';

import { Redirect } from 'pages/core/redirect/redirect';

import baseStyles from './add_pangolin_success.module.css';
import AddPangolinSuccessMessages from './add_pangolin_success_messages';
import encircledPangolin from './assets/encircled_pangolin.png';
import successCheck from './assets/success_check.png';


type AddPangolinSuccessStyles = {
  title: string;
  instructions: string;
  imageContainer: string;
  primaryImage: string;
  checkImage: string;
  actions: string;
};

const themedStyles: Record<Theme, AddPangolinSuccessStyles> = {
  [Theme.DAYLIGHT]: {
    title: baseStyles.daylightTitle,
    instructions: baseStyles.daylightInstructions,
    imageContainer: baseStyles.imageContainer,
    primaryImage: baseStyles.primaryImage,
    checkImage: baseStyles.checkImage,
    actions: baseStyles.actions,
  },
  [Theme.MIDNIGHT]: {
    title: baseStyles.midnightTitle,
    instructions: baseStyles.midnightInstructions,
    imageContainer: baseStyles.imageContainer,
    primaryImage: baseStyles.primaryImage,
    checkImage: baseStyles.checkImage,
    actions: baseStyles.actions,
  },
};

export const AddPangolinSuccess = observer(() => {
  const { pangolinID } = useParams<{ pangolinID: string }>();
  if (!pangolinID) return <Redirect />;

  const accounts = useAccountsDomain();
  const pangolin = accounts.pangolins.get(pangolinID);
  if (!pangolin) return <Redirect />;

  const styles = useStyles(themedStyles);

  const top = (
    <>
      <div className={styles.title}>
        {AddPangolinSuccessMessages.title(pangolin.nickname)}
      </div>
      <div className={styles.instructions}>
        {AddPangolinSuccessMessages.instructions()}
      </div>
    </>
  );

  const middle = (
    <div className={styles.imageContainer}>
      <img className={styles.primaryImage} src={encircledPangolin} alt=''/>
      <img className={styles.checkImage} src={successCheck} alt=''/>
    </div>
  );

  const bottom = (
    <div className={styles.actions}>
      <Link path={{ kind: BasePath.HOME, pangolinID: pangolin.id }}>
        <ActiveButton>
          {AddPangolinSuccessMessages.next()}
        </ActiveButton>
      </Link>
    </div>
  );

  return (
    <PartitionedPage top={top} middle={middle} bottom={bottom}/>
  );
});
